import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/Profile";
import Users from "./pages/Users";
import Invoices from "./pages/Invoices";
import Downloads from "./pages/Downloads";
import InviteAccept from "./pages/InviteAccept";
import Usage from "./pages/Usage";
import { UserRole } from "./types";

const HomeRedirect: React.FC = () => {
  const { user } = useAuth();

  if (!user) return null;

  return <Navigate to="/downloads" replace />;
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/invite/accept" element={<InviteAccept />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout>
                  <HomeRedirect />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Layout>
                  <Profile />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/downloads"
            element={
              <PrivateRoute
                allowedRoles={[UserRole.USER, UserRole.ADMIN, UserRole.SUPERADMIN]}
              >
                <Layout>
                  <Downloads />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/usage"
            element={
              <PrivateRoute
                allowedRoles={[UserRole.USER, UserRole.ADMIN, UserRole.SUPERADMIN]}
              >
                <Layout>
                  <Usage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/users"
            element={
              <PrivateRoute
                allowedRoles={[UserRole.SUPERADMIN, UserRole.ADMIN]}
              >
                <Layout>
                  <Users />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/invoices"
            element={
              <PrivateRoute allowedRoles={[UserRole.SUPERADMIN]}>
                <Layout>
                  <Invoices />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/billing"
            element={
              <PrivateRoute allowedRoles={[UserRole.ADMIN]}>
                <Layout>
                  <Invoices />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
